import { VColorPicker } from 'vuetify/lib/components/VColorPicker';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column flex-gap-16"},[_c('span',{staticClass:"grey--text text--darken-2"},[_vm._v(_vm._s(_vm.$t('Color')))]),_c(VColorPicker,_vm._b({model:{value:(_vm.color),callback:function ($$v) {_vm.color=$$v},expression:"color"}},'v-color-picker',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }